import { definePreset } from '@primeuix/themes';
import nora from '@primeuix/themes/nora';

// Chevron primary colour scale anchored on:
//   500 = $color-medium-blue (#0066b2) — main brand primary
//   800 = $color-dark-blue   (#0b2d71) — hover/dark variant
export const primetheme = definePreset(nora, {
  semantic: {
    primary: {
      50: '#e6f2fa',
      100: '#cce4f5',
      200: '#99c9eb',
      300: '#66ade1',
      400: '#3392d7',
      500: '#0066b2', // $color-medium-blue
      600: '#00529e',
      700: '#003d7a',
      800: '#0b2d71', // $color-dark-blue
      900: '#071e4b',
      950: '#040f25',
    },
  },
});
